import { render, staticRenderFns } from "./Transformation-Status.vue?vue&type=template&id=60e8998b&lang=pug"
import script from "./Transformation-Status.vue?vue&type=script&setup=true&lang=ts"
export * from "./Transformation-Status.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports